import { L2RButton, styledForMobile } from "@l2r-front/l2r-ui"

export const Button = styledForMobile(L2RButton)(({ isMobile }) => ({
    flex: isMobile && "1 1 auto",
}))

export const DrawContainer = styledForMobile("div")(() => ({
    zIndex: 1,
    height: 64,
}))